import { Link } from "react-router-dom";
import { useAppTranslation } from "../i18n/useAppTranslation";
import "./GuildRaidNotice.css";

type Props = {
  /** The guild the raid is for: the leader's guild, as the server reports it. */
  guildName?: string;
  /** Why this player cannot join, from the server; empty when they can. */
  joinError?: string | null;
};

/**
 * On a guild raid's join page: which guild the raid is for, and, when the player is not one of its
 * members, the server's reason they can't join (the Join button is disabled then).
 */
export default function GuildRaidNotice({ guildName, joinError }: Props) {
  const { t } = useAppTranslation(["treasure"]);
  return (
    <div className={joinError ? "grn-notice is-blocked" : "grn-notice"} role={joinError ? "alert" : "status"}>
      <div className="grn-text">
        <strong>
          {guildName ? t("treasure:join.guildRaid.title", { guild: guildName }) : t("treasure:detail.guildRaid")}
        </strong>
        <span>{joinError || t("treasure:join.guildRaid.membersOnly")}</span>
      </div>
      {joinError && (
        <Link className="grn-link" to="/guild">
          {t("treasure:join.guildRaid.openGuild")}
        </Link>
      )}
    </div>
  );
}
